import Login from '@/pages/Login'

import { Navigate } from 'react-router-dom'
import { isAuthenticated } from '../utils/auth'

export const LoginRedirect = () => {
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : <Login />
}
